import React, {Fragment} from "react";
import {NavLink} from "react-router-dom";
import {FormattedMessage} from "react-intl";
import ContextMenu from "../Utils/ContextMenu";
import classes from "./styles.module.css";

function TableRow({data}) {
    function status() {
        if (!data || data.status === undefined) return <div className={classes.Disabled}><FormattedMessage
            id="PrepaidTable.status.inactive" defaultMessage="Не активна"/></div>;
        switch (data.status) {
            case 0:
                return <div className={classes.Disabled}><FormattedMessage id="PrepaidTable.status.inactive"
                                                                           defaultMessage="Не активна"/></div>;
            case 1:
                return <div className={classes.Process}><FormattedMessage id="PrepaidTable.status.processing"
                                                                          defaultMessage="Обрабатывается"/></div>;
            case 2:
                return <div className={classes.Enables}><FormattedMessage id="PrepaidTable.status.active"
                                                                          defaultMessage="Активна"/></div>;
            case 3:
                return <div className={classes.Error}><FormattedMessage id="PrepaidTable.status.error"
                                                                        defaultMessage="Ошибка"/></div>;
            default:
                return <div className={classes.Disabled}><FormattedMessage id="PrepaidTable.status.inactive"
                                                                           defaultMessage="Не активна"/></div>;
        }
    }

    return (
        <Fragment>
            <tr className={classes.Row}>
                <td>{(data && data.ean) || ""}</td>
                <td>{data && data.part ? data.part.replace(/[*]{6}/g, " •••• ") : ""}</td>
                <td>{(data && data.merchantName) || ""}</td>
                <td>
                    <div>{(data && data.fio) || "—"}</div>
                </td>
                <td>{status()}</td>
                <td className={classes.CellMenu}>
                    <ContextMenu icon="menu">
                        <ul>
                            <li className={classes.MenuItem}>
                                <NavLink className={classes.defaultLink}
                                         to={`/prepaid/details/${(data && data.ean) || ""}`}>
                                    <FormattedMessage id="PrepaidTable.menu.details" defaultMessage="Детализация"/>
                                </NavLink>
                            </li>
                            {(data && (data.status === 0 || data.status === 3)) && (
                                <li className={classes.MenuItem}>
                                    <NavLink className={classes.ActivateLink}
                                             to={`/prepaid/activate/${(data && data.ean) || ""}`}>
                                        <FormattedMessage id="PrepaidTable.menu.activate" defaultMessage="Активация"/>
                                    </NavLink>
                                </li>
                            )}
                        </ul>
                    </ContextMenu>
                </td>
            </tr>
        </Fragment>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/PrepaidTable/TableRow.js